<template>
  <!-- Section Constructing Ethos Hero Start -->
  <section class="sec_Constructing_ethos_hero">
    <h2 class="card_heading_b" v-html="sanitizeHtml(shopifyData.preHeading)" />
    <div class="main_contenet">
      <h2 class="sec_heading" v-html="sanitizeHtml(shopifyData.secHeading)" />
      <h4 class="card_heading_b sec_inner_heading" v-html="sanitizeHtml(shopifyData.subHeading)" />
      <p
        v-for="(value, key) in shopifyData.blockData"
        :key="key"
        class="body_text"
        v-html="sanitizeHtml(value.para)"
      />
    </div>
    <div class="sec_slider">
      <div class="sec_slider modify-slider">
        <swiper
          :navigation="false"
          :modules="modules"
          :centered-slides="true"
          :space-between="100"
          :loop="true"
          :effect="'fade'"
          class="mySwiper"
        >
          <swiper-slide v-for="(value, key) in shopifyData.SlidedynamicData" :key="key">
            <img
              v-lazy="value.imgUrl.src"
              :src-placeholder="value.imgUrl.placeholder"
              :alt="value.imgUrl.alt || 'Constructing Ethos Hero Image'"
              loading="lazy"
              aria-hidden="true"
              aria-label="Constructing Ethos Hero Image"
              width=""
              height=""
            />
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <p class="subtitle" v-html="sanitizeHtml(shopifyData.afterImageText)" />
  </section>
  <!-- Constructing Ethos Hero Start -->
</template>

<script>
import { sanitizeHtml } from '@/sanitizeContent.js';
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';

import 'swiper/css/navigation';

// import required modules
import { Navigation, Autoplay, EffectFade } from 'swiper';
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      modules: [Navigation, Autoplay, EffectFade],
    };
  },
  methods: {
    sanitizeHtml,
  },
};
</script>

<style scoped>
.sec_Constructing_ethos_hero {
  padding-top: 60px;
  position: relative;
}
.sec_Constructing_ethos_hero::after {
  content: '';
  position: absolute;
  top: 45px;
  left: 0;
  height: calc(100% - 100px);
  width: 100%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #e9e7e3 100%);
  z-index: -1;
}
.card_heading_b {
  margin-bottom: 62px;
  text-align: center;
  text-transform: initial;
}
.card_heading_b.sec_inner_heading {
  margin: 14px 0;
  text-align: start;
}
.subtitle {
  margin: 6px 0 0 18px;
}

.sec_video iframe {
  width: 100%;
  height: 715px;
}
.sec_heading {
  line-height: 44px;
}
.main_contenet {
  max-width: 665px;
  margin: 0 auto 61px auto;
  width: 100%;
}

.sec_content {
  display: grid;
  grid-template-columns: 28% 64%;
  align-items: center;
  margin-top: 34px;
  gap: 30px;
}

.body_text {
  line-height: 19px;
  margin-bottom: 20px;
}
.body_text:last-child {
  margin-bottom: 0px;
}
.sec_img {
  margin-top: 75px;
}
/* Responsive Css Code */
@media screen and (max-width: 991px) {
  .sec_Constructing_ethos_hero {
    padding-top: 44px;
  }
  .main_contenet {
    padding: 0 20px;
    margin-bottom: 35px;
  }
  .sec_img {
    margin-top: 5px;
  }
  .card_heading_b {
    margin-bottom: 50px;
  }
}

@media screen and (max-width: 767px) {
  .main_contenet {
    margin-bottom: 22px;
  }
  .subtitle {
    margin: 12px 0 0 10px;
  }
}
</style>
